import { FC, ReactElement } from 'react';

import { ListProps } from './List.interface';
import './List.css';
import cn from 'utils/cn';

/*
  This component is a container for the <ListItem /> component
  It displays a list w/alternating background color on the even items
  It also has a border-bottom hover style applied.
  If you don't want to have the alternating background color and hover style, use the <TextList /> component
*/
const List: FC<ListProps> = ({ children, ulProps = {} }): ReactElement<any> => {
  return (
    <ul
      {...ulProps}
      className={cn(`mume-list tw:list-none tw:pl-0 tw:m-0 tw:overflow-hidden`, ulProps?.className)}
    >
      <>{children}</>
    </ul>
  );
};

export default List;
